// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2_tfZ","consentsList":"PatientConsents_consentsList__vjTer","consentsListEmpty":"PatientConsents_consentsListEmpty__30gk1"};